// removed by extract-text-webpack-plugin
module.exports = {"btnPrimary":"btnPrimary___2uHtA","modal":"modal___YQpmI"};